var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMoMenuM02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6327 36.9486V8.94727H22.5853V15.6209H12.1228V23.339H1V36.9486H37.6327Z",
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4729 30.9217C22.4729 36.4901 26.9876 41.0001 32.5513 41.0001C38.1151 41.0001 42.6298 36.4854 42.6298 30.9217C42.6298 25.3579 38.1151 20.8433 32.5513 20.8433C26.9876 20.8433 22.4729 25.3579 22.4729 30.9217Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.425 23.9385V31.0805H38.0403",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.425 23.9385V31.0805H38.0403",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4739 31.1645C31.4739 31.7593 31.9563 32.2417 32.551 32.2417C33.1458 32.2417 33.6235 31.7593 33.6235 31.1645C33.6235 30.5697 33.1411 30.092 32.551 30.092C31.9609 30.092 31.4739 30.5744 31.4739 31.1645Z",
    fill: "#D4ECD0",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5625 9.11145C16.5625 4.62955 20.192 1 24.674 1C29.1559 1 32.7854 4.62955 32.7854 9.11145C32.7854 13.5934 29.1559 17.2229 24.674 17.2229C20.192 17.2229 16.5625 13.5934 16.5625 9.11145Z",
    fill: "white",
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8592 9.11206H25.4889C26.2289 9.11206 26.8237 9.84265 26.8237 10.7418C26.8237 11.641 26.2242 12.3716 25.4889 12.3716H23.8592C23.1239 12.3716 22.5244 11.641 22.5244 10.7418",
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4889 9.11186H23.8592C23.1239 9.11186 22.5244 8.38127 22.5244 7.48208C22.5244 6.58289 23.1239 5.85229 23.8592 5.85229H25.4889C26.2289 5.85229 26.8237 6.58289 26.8237 7.48208",
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6738 12.3953V13.9267",
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6736 4.29736V5.82411",
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoMenuM02);
export default __webpack_public_path__ + "static/media/ic_mo_menu_m02.76eabf425994bb7422632c3f7639645f.svg";
export { ForwardRef as ReactComponent };